import { deleteCookie, getCookieByName, setCookie } from "@/js/helpers/cookieManager";
import store from "@/js/store";

export function getAffiliateVisitorId() {
	const currentUser = store.getters.currentUser;

	if (currentUser?.partnerStackId) {
		return { partnerStackId: currentUser.partnerStackId };
	} else {
		return { papCookie: getPAPId() };
	}
}
// -----------------------------------------

// PARTNER STACK
// PS ID saving chain:
// https://dripify.atlassian.net/wiki/x/BgDOCw?atlOrigin=eyJpIjoiZjM2MmNhZGMwYTgzNDkxNTlhZjQ1MDk5OTdiZGUzN2MiLCJwIjoiYyJ9

const PS_COOKIE_NAME = "psXid";

export function getPsIdAndWriteCookie() {
	const psXid = getPartnerStackIdFromUrl();

	if (psXid) setCookie(PS_COOKIE_NAME, psXid, 10);
}

export function getPsIdFromCookie() {
	return getCookieByName(PS_COOKIE_NAME);
}

export function removePsIdFromCookie() {
	deleteCookie(PS_COOKIE_NAME);
}

function getPartnerStackIdFromUrl() {
	const url = window.location.href;
	const urlObj = new URL(url);

	return urlObj.searchParams.get("ps_xid");
}

export async function findSavedPsId() {
	const userInfo = await store.dispatch("readUserInfoFromFirebaseDB");

	if (userInfo && userInfo.psXid) {
		return userInfo.psXid;
	} else {
		// in case psXid didn't save in firebase DB before (unpredicted)
		return getPsIdFromCookie();
	}
}

export function sendPsData(psXid, name) {
	const { userInfo } = store.getters;

	if (userInfo) {
		store.dispatch("createCustomerRecordInPartnerStack", {
			psId: psXid,
			email: userInfo.email,
			name
		});
	}
}
// -----------------------------------------

// POST AFFILIATE PRO
function getPAPId() {
	return window.PostAffTracker
		? window.PostAffTracker._cmanager.getVisitorIdOrSaleCookieValue()
		: "";
}

